import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-basic-select',
  templateUrl: './basic-select.component.html',
  styleUrls: ['./basic-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: BasicSelectComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: BasicSelectComponent,
    },
  ],
})
export class BasicSelectComponent implements ControlValueAccessor, Validator {
  @Input()
  title = 'Select option...';

  @Input()
  iconClass: string = 'menu-app fw-semibold';

  public className = '';

  @Input()
  public options!: Array<string>;

  @Input()
  public selectedOption?: string = '';

  @Input() isRequired = false;

  @Input()
  isDisabled = false;

  @Input()
  showIcon = true;

  @Input()
  showSearch = true;

  @Input()
  breakAndCapitaliseWords = false;

  @ViewChild('searchElement')
  searchElement?: ElementRef;

  @ViewChild('dropdown')
  dropdown!: NgbDropdown;

  public searchKey = '';
  public filteredOptions: any;

  constructor() {
    this.className =
      'item_' +
      Math.floor(Math.random() * (9999999 - 1111111) + 1111111).toString();
    this.filteredOptions = this.options;
  }

  ngOnInit(): void { }

  onChange = (option: string | undefined) => { };

  onTouched = () => { };

  touched = false;

  disabled = false;

  onItemClick(option: string) {
    this.markAsTouched();
    if (!this.disabled) {
      this.selectedOption = option;
      this.onChange(this.selectedOption);
    }
  }

  search() {
    const key = this.searchKey.trim();
    if (key.length >= 1 && this.options.length) {
      this.filteredOptions = this.options.filter(
        (a) => a.toLowerCase().indexOf(key.toLowerCase()) >= 0
      );
    } else {
      this.filteredOptions = this.options;
    }
  }

  scrollToView(): void {
    const elementList = document.querySelector('.' + this.className);
    const element = elementList as HTMLElement;

    if (element) {
      element.scrollIntoView({ behavior: 'instant', block: 'nearest' });
    }
  }

  onOpenDropdown() {
    this.searchKey = '';
    this.filteredOptions = this.options;
    setTimeout(() => {
      this.searchElement?.nativeElement.focus();
      this.scrollToView();
    }, 100);
  }

  removeSelected(event: any) {
    event.stopPropagation();
    this.markAsTouched();
    this.selectedOption = undefined;
    this.onChange(this.selectedOption);
  }

  writeValue(option: string) {
    this.selectedOption = option;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  searchKeyDown(key: KeyboardEvent) {
    if (key.key == 'Enter') {
      this.selectFirstResult();
      this.dropdown.close();
    }
  }

  selectFirstResult() {
    this.onItemClick(this.filteredOptions[0]);
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const option = control.value;
    if (this.selectedOptionIsNotset()) {
      return null;
    }
    return null;
  }

  selectedOptionIsNotset() {
    return (
      this.selectedOption === null ||
      this.selectedOption === undefined ||
      this.selectedOption?.trim() === ''
    );
  }
}
